import { PlaybackStore } from '@ibiquity/dashboard.audio-player';

const state = {
  ...PlaybackStore.state,

  broadcastId: null,
  index: undefined,
};

/* eslint-disable no-param-reassign, no-shadow */
const actions = {
  ...PlaybackStore.actions,

  switchPlayback: async ({ commit, getters }, { broadcastId, index, streams }) => {
    const isCurrentlyPlaying = getters.isGivenBroadcastPlaying(broadcastId, index);
    commit('setStreams', streams);
    commit('setActive', !isCurrentlyPlaying);
    commit('setCurrentBroadcast', { broadcastId, index });
  },
};

const mutations = {
  ...PlaybackStore.mutations,

  setCurrentBroadcast(state, { broadcastId, index }) {
    state.broadcastId = broadcastId;
    state.index = index;
  },
};

const getters = {
  ...PlaybackStore.getters,

  activeBroadcastId: (state) => {
    if (state.active) return state.broadcastId;
    return null;
  },
  isGivenBroadcastCurrent(state) {
    return ({ broadcastId, index }) => state.broadcastId === broadcastId && state.index === index;
  },
  isGivenBroadcastPlaying(state, getters) {
    return (broadcastId, index) => state.active
      && getters.isGivenBroadcastCurrent({ broadcastId, index });
  },
  isGivenBroadcastBuffering(state, getters) {
    return (broadcastId, index) => state.buffering
      && getters.isGivenBroadcastCurrent({ broadcastId, index });
  },
  hasGivenBroadcastFailed(state, getters) {
    return (broadcastId, index) => state.error
      && getters.isGivenBroadcastCurrent({ broadcastId, index });
  },
};
/* eslint-enable no-param-reassign, no-shadow */

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
